export default defineNuxtRouteMiddleware(async (to, from) => {
  const { waitForUserLogin } = useAuth()

  if (await waitForUserLogin()) {
    // if from.name is undefined we have a fresh load. Otherwise the login page should be accessible.
    if (to.path !== '/login' || from.name) {
      return
    }

    const path = to.query.redirect?.toString() || '/'

    return navigateTo({
      path,
      replace: true,
    })
  }

  if (to.meta.authenticated === false) {
    return
  }

  let redirect: string | undefined = undefined

  if (to.fullPath !== '/') redirect = to.fullPath

  return navigateTo({
    path: '/login',
    replace: true,
    query: {
      redirect,
    },
  })
})
